<template>
	<div class="Dropdown" :class="{ reverse: reverse, primary: primary, right: right }" tabindex="-1">
		<h3 class="Dropdown-heading u-text-3" tabindex="-1">
			<!-- @slot This holds the heading-->
			<slot name="heading" />
			<CloIcon v-if="icon" symbol="triangleDown" size="sm" />
			<span class="Dropdown-closer" @click="$el.focus()"></span>
		</h3>
		<div class="Dropdown-panel" tabindex="-1">
			<!-- @slot This holds the panel-->
			<slot name="panel" />
		</div>
	</div>
</template>

<script>
import CloIcon from '@/icons/CloIcon/CloIcon.vue';

export default {
	components: { CloIcon },
	name: 'Dropdown',
	props: {
		/**
		 * Whether to use an icon or not
		 */
		icon: {
			type: Boolean,
			default: true,
		},
		/**
		 * Whether dropdown is reversed or not
		 */
		reverse: {
			type: Boolean,
			default: false,
		},
		/**
		 * Whether it is a primary dropdown or not
		 */
		primary: {
			type: Boolean,
			default: false,
		},
		/**
		 * Dropdown on right or not
		 */
		right: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss">
.Dropdown {
	position: relative;
	outline: 0;
	display: inline-flex;
}
.Dropdown-heading {
	display: inline-flex;
	align-items: center;
	position: relative;
	outline: 0;
	font-weight: normal;
	color: $color-link;
	padding: $space-xs;
	.reverse & {
		color: $color-link-reverse;
	}
	cursor: pointer;
	.Icon--triangleDown {
		margin: 0 $space-xs;
	}
}
.Dropdown-panel {
	z-index: 4;
	position: absolute;
	height: 1px;
	width: 1px;
	overflow: hidden;
	clip: rect(1px, 1px, 1px, 1px);
	outline: 0;
	.right & {
		right: 0;
		[dir='rtl'] & {
			left: 0;
			right: auto;
		}
	}
	ul li a {
		display: block;
		padding: $space-xs 0;
	}
}
.Dropdown-closer {
	display: none;
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
}

.Dropdown-heading:focus-within + .Dropdown-panel,
.Dropdown-panel:focus-within {
	height: auto;
	width: auto;
	overflow: auto;
	clip: auto;
	top: 100%;
	min-width: 20rem;
	max-width: 100%;
	padding: $space-md;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
	background-color: $color-white;
	.primary & {
		background-color: $color-primary-0;
	}
	.reverse & {
		background-color: $color-neutral-5;
	}
	.reverse.primary & {
		background-color: $color-primary-5;
	}
}
.Dropdown-heading:focus-within .Dropdown-closer,
.Dropdown-panel:focus-within ~ .Dropdown-heading .Dropdown-closer {
	display: inline-block;
}

// hover is for IE11 which does not support focus-within
// barely works here because the panel is positioned away from the button
// so you need to move the cursor very fast
@media all and (-ms-high-contrast: none), (-ms-high-contrast: none) {
	.Dropdown-heading:hover + .Dropdown-panel,
	.Dropdown-panel:hover {
		height: auto;
		width: auto;
		overflow: auto;
		clip: auto;
		top: 100%;
		min-width: 12rem;
		max-width: 14rem;
		padding: $space-md;
		box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
		background-color: $color-white;
		.primary & {
			background-color: $color-primary-0;
		}
		.reverse & {
			background-color: $color-neutral-5;
		}
		.reverse.primary & {
			background-color: $color-primary-5;
		}
	}
}
// also for Edge 15-18 (non-chromium)
@supports (display: -ms-grid) {
	.Dropdown-heading:hover + .Dropdown-panel,
	.Dropdown-panel:hover {
		height: auto;
		width: auto;
		overflow: auto;
		clip: auto;
		top: 100%;
		min-width: 12rem;
		max-width: 14rem;
		padding: $space-md;
		box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
		background-color: $color-white;
		.primary & {
			background-color: $color-primary-0;
		}
		.reverse & {
			background-color: $color-neutral-5;
		}
		.reverse.primary & {
			background-color: $color-primary-5;
		}
	}
}
</style>
